/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../app/welcome/welcome.component';
import * as i2 from '@angular/router';
const styles_WelcomeComponent:any[] = ['.welcome-panel[_ngcontent-%COMP%] { text-align:center;margin:100px; }'];
export const RenderType_WelcomeComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:0,
    styles:styles_WelcomeComponent,data:{}});
export function View_WelcomeComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n'])),(_l()(),i0.ɵeld(0,(null as any),
      (null as any),4,'div',[['class','col-lg-12 welcome-panel']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n    '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),1,'h1',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          ['\n        Welcome to Scania PackIT.\n    '])),(_l()(),i0.ɵted((null as any),
          ['\n']))],(null as any),(null as any));
}
export function View_WelcomeComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'welcome',([] as any[]),
      (null as any),[['window','beforeunload']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('window:beforeunload' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).canDeactivate()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_WelcomeComponent_0,RenderType_WelcomeComponent)),i0.ɵdid(114688,(null as any),
      0,i1.WelcomeComponent,[i2.Router],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const WelcomeComponentNgFactory:i0.ComponentFactory<i1.WelcomeComponent> = i0.ɵccf('welcome',
    i1.WelcomeComponent,View_WelcomeComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvUEJBQkg3L1dvcmtzcGFjZS9PblByZW1DaGluYS9QYWNrSVRXZWJHdWkvc3JjL2FwcC93ZWxjb21lL3dlbGNvbWUuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0M6L1VzZXJzL1BCQUJINy9Xb3Jrc3BhY2UvT25QcmVtQ2hpbmEvUGFja0lUV2ViR3VpL3NyYy9hcHAvd2VsY29tZS93ZWxjb21lLmNvbXBvbmVudC50cyIsIm5nOi8vL0M6L1VzZXJzL1BCQUJINy9Xb3Jrc3BhY2UvT25QcmVtQ2hpbmEvUGFja0lUV2ViR3VpL3NyYy9hcHAvd2VsY29tZS93ZWxjb21lLmh0bWwiLCJuZzovLy9DOi9Vc2Vycy9QQkFCSDcvV29ya3NwYWNlL09uUHJlbUNoaW5hL1BhY2tJVFdlYkd1aS9zcmMvYXBwL3dlbGNvbWUvd2VsY29tZS5jb21wb25lbnQudHMuV2VsY29tZUNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxyXG48ZGl2IGNsYXNzPVwiY29sLWxnLTEyIHdlbGNvbWUtcGFuZWxcIj5cclxuICAgIDxoMT5cclxuICAgICAgICBXZWxjb21lIHRvIFNjYW5pYSBQYWNrSVQuXHJcbiAgICA8L2gxPlxyXG48L2Rpdj4iLCI8d2VsY29tZT48L3dlbGNvbWU+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBLHVDQUNBO01BQUE7TUFBQSw0Q0FBcUM7TUFDakM7VUFBQSwwREFBSTtVQUFBLGdEQUVDO1VBQUE7OztvQkNKVDtNQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO01BQUEsK0RBQUE7TUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/$$_gendir/app/welcome/welcome.component.ngfactory.ts